import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const SecuritiesSubAccount = React.lazy(() =>
    import('../SecuritiesSubAccount')
);
const securitiesSubAccountRoutesRegistry = [
    {
        path: PAGE_URL.SECURITIES_SUB_ACCOUNT_PAGE,
        element: <SecuritiesSubAccount />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default securitiesSubAccountRoutesRegistry;
